import { render, staticRenderFns } from "./Medicamento.vue?vue&type=template&id=6a947d6c&scoped=true&"
import script from "./Medicamento.vue?vue&type=script&lang=js&"
export * from "./Medicamento.vue?vue&type=script&lang=js&"
import style0 from "./Medicamento.vue?vue&type=style&index=0&id=6a947d6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a947d6c",
  null
  
)

export default component.exports